import React from "react";
import { useAuth, ROLE_LABEL } from "../lib/auth";
import { Card } from "../components/ui/card";
import { DataField } from "../components/DataField";
import { Settings as SettingsIcon, Sparkles, ShieldCheck, BookOpen } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="space-y-8" data-testid="settings-page">
      <header>
        <div className="text-[10px] tracking-[0.22em] uppercase font-semibold text-[#8B5A2B]">Settings</div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-bold text-[#2C2A28] mt-2">Your profile & system</h1>
      </header>

      <Card className="p-7 border-[#E6E2D8] shadow-sm bg-white">
        <div className="flex items-center gap-3 mb-5">
          <SettingsIcon className="w-4 h-4 text-[#8B5A2B]" strokeWidth={1.8} />
          <h2 className="font-display text-xl font-semibold text-[#2C2A28]">Account</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-x-8 gap-y-5">
          <DataField label="Name" value={user.name} testid="set-name" />
          <DataField label="Email" value={user.email} testid="set-email" />
          <DataField label="Role" value={ROLE_LABEL[user.role] || user.role} testid="set-role" />
          <DataField label="Organisation" value={user.organisation} testid="set-org" />
          <DataField label="Traditional Owner group" value={user.traditional_owner_group} testid="set-to" />
        </div>
      </Card>

      <div className="grid md:grid-cols-3 gap-5">
        <InfoCard icon={ShieldCheck} title="Cultural data protection" body="Restricted cultural fields (elder notes, traditional uses, cultural name, governance) are visible only to System Admins and the Traditional Owner Admin for that group. Project Partners may see additional fields when partner sharing is approved." />
        <InfoCard icon={Sparkles} title="Provenance Intelligence" body="The AI engine in this version is rule-based and labelled draft intelligence. AI analysis is opt-in per collection. A future release may connect to an LLM only when explicit cultural permission allows." />
        <InfoCard icon={BookOpen} title="Product philosophy" body="Indigenous provenance is more than data: it is Country, people, permission, ecological context, genetic resilience, climate future, cultural authority, and restoration purpose." />
      </div>
    </div>
  );
}

function InfoCard({ icon: Icon, title, body }) {
  return (
    <Card className="p-6 border-[#E6E2D8] shadow-sm bg-white">
      <div className="w-9 h-9 rounded-md bg-[#F4F1EA] border border-[#E6E2D8] flex items-center justify-center">
        <Icon className="w-4 h-4 text-[#8B5A2B]" strokeWidth={1.6} />
      </div>
      <h3 className="font-display text-base font-semibold text-[#2C2A28] mt-4">{title}</h3>
      <p className="text-[12.5px] leading-relaxed text-[#5C5854] mt-2">{body}</p>
    </Card>
  );
}
